export default __webpack_public_path__ + "static/media/Julie-Subrin.c3c13972.jpg";